// Largos que acepta la API para una parte del libro (cBookParty.PartyCode / cBookParty.Name).
// Son los mismos de privilege_element_party y del código y nombre de la entidad legal / unidad de negocio.
export const PARTY_CODE_MAX_LENGTH = 150;
export const PARTY_NAME_MAX_LENGTH = 250;

const VALUE_PREVIEW_LENGTH = 40;

const toText = (value) => (value === null || value === undefined ? '' : String(value));

const toPreview = (value) => (value.length > VALUE_PREVIEW_LENGTH ? `${value.slice(0, VALUE_PREVIEW_LENGTH)}...` : value);

// Devuelve, por cada parte a guardar, los campos que no entran en lo que acepta la API
// (código vacío o de más de 150 caracteres, nombre vacío o de más de 250).
export const findPartyLengthErrors = (parties) => {
    const errors = [];

    (Array.isArray(parties) ? parties : []).forEach(party => {
        const code = toText(party.partyCode);
        const name = toText(party.name);

        if (code.length < 1 || code.length > PARTY_CODE_MAX_LENGTH) {
            errors.push({ field: 'code', value: toPreview(code), length: code.length, max: PARTY_CODE_MAX_LENGTH });
        }

        if (name.length < 1 || name.length > PARTY_NAME_MAX_LENGTH) {
            errors.push({ field: 'name', value: toPreview(name), length: name.length, max: PARTY_NAME_MAX_LENGTH });
        }
    });

    return errors;
};
